import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FaxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fax"}/>
}
